export const state = () => ({
    user: {},
    company: {},
    token: '',
    expires: '',
});